<template>
  <div class="home">
      <VideoFullScreen></VideoFullScreen>
      <Mosaico></Mosaico>
  </div>
</template>

<script>
// @ is an alias to /src
import VideoFullScreen from '@/components/home/Video.vue';
import Mosaico from '@/components/home/Mosaico.vue';

export default {
  name: 'MOA',
  components: {
    VideoFullScreen,
    Mosaico
  },
  metaInfo() {
    return {
      title: 'MOA',
      meta: [
        {name: 'title', content:'Matteo Ortili Art'},
        {name: 'description', content: 'Home page of Matteo Ortili photographer site'},
        {property: 'og:title', content: "Matteo Ortili Art"},
        {property: 'og:site_name', content: 'MatteOrtiliArt (MOA)'},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: 'https://www.matteortili.com/#/'},
        {property: 'og:description', content: 'Home page of Matteo Ortili photographer site'},
        {property: 'og:image:secure_url', itemprop: 'image', content: 'https://www.matteortili.com/imgs/link_img.jpg'},
      ]
    }
  }
}
</script>
